<template>
    <div>
		<card>
			<div class="multiple">
				<div class="child-div">时间区间</div>
				<RadioGroup v-model="timePeriod" @on-change="getList">
					<Radio label="0"><span>不限</span></Radio>
					<Radio label="1"><span>今日</span></Radio>
					<Radio label="2"><span>昨日</span></Radio>
					<Radio label="3"><span>本周</span></Radio>
					<Radio label="4"><span>上周</span></Radio>
					<Radio label="5"><span>本月</span></Radio>
					<Radio label="6"><span>上月</span></Radio>
					<Radio label="7"><span>自定义</span></Radio>
					<DatePicker :value="timePeriodDate" @on-change="timePeriodDateChange" type="daterange"
								placeholder="选择日期" style="width: 200px"></DatePicker>
				</RadioGroup>
			</div>
			<div class="multiple">
				<div class="child-div">跟进团队</div>
					<Select v-model="followDepartment" clearable @on-change="getList" style="width:150px;"
						placeholder="跟进团队">
						<Option v-for="item in departmentList" :value="item.value" :key="item.value">{{ item.label }}
						</Option>
					</Select>
					<Select v-model="mediumCodeId" clearable @on-change="getList" style="width:150px;"
						placeholder="来源">
						<Option v-for="item in mediumcodeidList" :value="item.value" :key="item.value">{{ item.label }}
						</Option>
					</Select>
					<Button style="margin-left: 20px;" type="primary" v-on:click="initSearch()">重置</Button>
			</div>
			<!--div class="multiple">
				<div class="child-div">统计方式</div>
				<RadioGroup v-model="statisticsWay" @on-change="getList">
					<Radio :label="1"><span>媒体代码</span></Radio>
					<Radio :label="2"><span>媒体渠道</span></Radio>
				</RadioGroup>
				<Button class='ivu-btn-circle' style="margin-left: 30px" type="primary" @click="getList">搜索</Button>
			</div-->
			<!--div class="multiple">
				<div class="child-div">统计方式</div>
				<RadioGroup v-model="statisticsWay">
					<Radio :label="1"><span>媒体代码</span></Radio>
					<Radio :label="2"><span>媒体渠道</span></Radio>
				</RadioGroup>
			</div>
			<div class="multiple">
				<div class="child-div">下级渠道</div>
				<Select v-model="shopId" style="width:200px">
					<Option v-for="item in shopList" :value="item.value" :key="item.value">
						{{ item.label }}
					</Option>
				</Select>
				<Button class='ivu-btn-circle' style="margin-left: 30px" type="primary" @click="getList">搜索</Button>
				<Button class='ivu-btn-circle' style="margin-left: 15px" @click="initSearch">重置</Button>
			</div-->			
		</card>
        <div style="width: 100% ; margin-top: 20px;">
            <Table stripe border :columns="columns" :data="datas"  ref="table">
				<template slot-scope="{ row }" slot="name">
					<span >{{row.name}}</span>
				</template>
				<template slot-scope="{ index,row }" slot="first_num">
					<span  style="color:#63B3E6;cursor: pointer;" @click.stop="clientClick(0,0,row.id,1,3)">{{row.first_num}}</span>
				</template>
				<template slot-scope="{ index,row }" slot="status_1">
					<span  style="color:#63B3E6;cursor: pointer;" @click.stop="clientClick(1,0,row.id,1,3)">{{row.status_1}}</span>
				</template>
				<template slot-scope="{ index,row }" slot="status_2">
					<span  style="color:#63B3E6;cursor: pointer;" @click.stop="clientClick(2,0,row.id,1,3)">{{row.status_2}}</span>
				</template>
				<template slot-scope="{ index,row }" slot="status_3">
					<span  style="color:#63B3E6;cursor: pointer;" @click.stop="clientClick(3,0,row.id,1,3)">{{row.status_3}}</span>
				</template>
				<template slot-scope="{ index,row }" slot="start_0">
					<span  style="color:#63B3E6;cursor: pointer;" @click.stop="clientClick(0,1,row.id,1,3)">{{row.start_0}}</span>
				</template>
				<template slot-scope="{ index,row }" slot="start_0_rate">
					<span  style="color:#63B3E6;cursor: pointer;" @click.stop="clientClick(0,1,row.id,1,3)">{{row.start_0_rate}}</span>
				</template>
				<template slot-scope="{ index,row }" slot="start_1">
					<span  style="color:#63B3E6;cursor: pointer;" @click.stop="clientClick(0,2,row.id,1,3)">{{row.start_1}}</span>
				</template>
				<template slot-scope="{ index,row }" slot="start_2">
					<span  style="color:#63B3E6;cursor: pointer;" @click.stop="clientClick(0,3,row.id,1,3)">{{row.start_2}}</span>
				</template>
				<template slot-scope="{ index,row }" slot="start_3">
					<span  style="color:#63B3E6;cursor: pointer;" @click.stop="clientClick(0,4,row.id,1,3)">{{row.start_3}}</span>

				</template>
				<template slot-scope="{ index,row }" slot="start_4">
					<span  style="color:#63B3E6;cursor: pointer;" @click.stop="clientClick(0,5,row.id,1,3)">{{row.start_4}}</span>

				</template>
				<template slot-scope="{ index,row }" slot="start_5">
					<span  style="color:#63B3E6;cursor: pointer;" @click.stop="clientClick(0,6,row.id,1,3)">{{row.start_5}}</span>

				</template>
				<template slot-scope="{ index,row }" slot="start_3_plus">
					<span  style="color:#63B3E6;cursor: pointer;" @click.stop="clientClick(0,7,row.id,1,3)">{{row.start_4+row.start_5}}</span>

				</template>
				<template slot-scope="{ index,row }" slot="start_3_plus_rate">
					<span  style="color:#63B3E6;cursor: pointer;" @click.stop="clientClick(0,7,row.id,1,3)">{{row.start_3_plus_rate}}</span>

				</template>				
            </Table>
        </div>
		<Modal v-model="clickJumpClientShow" width="1300" height="500">
			<ClickJumpClient ref="ClickJumpClient" :timePeriod="timePeriod" :timePeriodDate="timePeriodDate"  :get_uid="get_uid" :client_type="client_type" :start="start" :timeType="timeType" :status="status" :is_redistribution="is_redistribution"></ClickJumpClient>
		</Modal>
    </div>
</template>
<script>
    import {getAllMediumCode, getAllMedium, getMediaStatics, getAllShop} from "../../api/runSet";
	import {getClientNums,getClientStatics,getDataReport} from "../../api/statics.js";
	import {mapGetters} from "vuex";
	import {
		getDepartmentList,
	} from '@/api/user'
	import ClickJumpClient from '../client/ClickJumpClient.vue';
	export default {
        name: "data_report",
        components: {
			ClickJumpClient
		},

        data() {
            return {
                modal: false,
				clickJumpClientShow:false,
                timePeriod: '3',
				timeType:'1',
				get_uid:'',
				status:1,
				start:0,
				client_type:5,
				is_redistribution:1,
                statisticsWay: 1,
                timePeriodDate: [],
                shopId: '',
                shopList: [
                ],
				mediumcodeidList: [],
				departmentList: [],
				mediumCodeId:'',
				followDepartment:'',
                datas: [],
                columns: [
					{
					    "title": "排序",
					    "type": "index",
						"align":"center",
					    "width": 60,
					},
                    {
                        "title": "名称",
                        "slot": "name",
						"align":"center",
                        "width": 120,
                    },
					{
					    "title": "部门",
					    "key": "department_name",
						"align":"center",
					    "width": 120,
					},
					{
						"title": "状态",
						"key": "del",
						"align": "center",
						"width": 120,
						render: (h, params) => { // 根据条件判断内容重写
							switch (params.row.del) {
								case 0:
									return h('span', '在职')
								case 1:
									return h('span', '离职')
							}
						},
						"filteredValue":[0],
						filters: [ // 过滤条件 
							{
								label: '在职',
								value: '0'
							},
							{
								label: '离职',
								value: '1'
							},
						],
						filterMethod(value, row) { // 过滤方法
							return row.del == value
						}

					},
                    {
                        "title": "数量",
                        "slot": "first_num",
						"align":"center",
                        "width": 100,
                    },
					{
					    "title": "线上数量",
					    "key": "xianshang_first_num",
						"align":"center",
					    "width": 100,
					},
					{
					    "title": "未处理",
					    "slot": "status_1",
						"align":"center",
					    "width": 75,
					},
					{
					    "title": "待跟进",
					    "slot": "status_2",
						"align":"center",
					    "width": 75,
					},
					{
					    "title": "邀约中",
					    "slot": "status_3",
						"align":"center",
					    "width": 75,
					},
                    {
                        "title": "0星",
                        "slot": "start_0",
						"align":"center",
                        "width": 100,
                    },
                    {
                        "title": "0星占比",
                        "slot": "start_0_rate",
						"align":"center",
                        "width": 100,
                    },					
                    {
                        "title": "1星",
                        "slot": "start_1",
						"align":"center",
                        "width": 100,
                    },
                    {
                        "title": "2星",
                        "slot": "start_2",
						"align":"center",
                        "width": 100
                    },
                    {
                        "title": "2星+",
                        "slot": "start_3",
						"align":"center",
                        "width": 100
                    },
                    {
                        "title": "3星",
                        "slot": "start_4",
						"align":"center",
                        "width": 100
                    },
                    {
                        "title": "4星",
                        "slot": "start_5",
						"align":"center",
                        "width": 100,
                    },
                    {
                        "title": "3星以上",
                        "slot": "start_3_plus",
						"align":"center",
                        "width": 100,
                    },
					{
					    "title": "优质占比",
					    "slot": "start_3_plus_rate",
						"align":"center",
					    "width": 100,
					},
                ],
            }
        },
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted: function () {
			this.loadData();
			this.getList();
		},
        methods: {
			timePeriodDateChange(e) {
				this.timePeriodDate = e;
				this.getList();
			},
			clientClick(status,start,get_uid,timeType,client_type) {
				let that = this;
				//time:时间  today：今天 yesterday:昨天 week:本周 thismonth:本月
				//timeType:时间类型 1：客户申请时间 2：分发时间 3、备注更新时间
				//
				that.status = status;				
				that.start = start;			
				that.get_uid = get_uid?get_uid:0;
				that.timeType = timeType;
				that.client_type = client_type;
				that.clickJumpClientShow = true;
				/*
				let routeData = this.$router.resolve({
				    name: 'ClickJumpClient',
				    query: {
						get_uid:get_uid,
						status:status,
						start:start,
						timePeriod:this.timePeriod,
						timePeriodDate:this.timePeriodDate,
						timeType:timeType
				    }
				})
				*/
			},
			initSearch() {
				this.mediumCodeId = '';
				this.statisticsWay = 1;
				this.mediumId = '';
				this.timePeriod = '1';
				this.timePeriodDate = [];
				this.followDepartment = '',
				this.getList();
			},
			async loadData() {
				let that = this;
				let data = {}
				data.token = this.token;
				let res = await getAllShop(that, data);
				that.shopList = res.data.list;
				res = await getAllMediumCode(that, data);
				that.mediumcodeidList = res.data.list;
				res = await getDepartmentList(that, data);
				if (res.code == 1) {
					that.departmentList = res.data.list;
				}
			},
			async getList() {
				let that = this;
				var data = this.$data;
				data.token = this.token;
				let res = await getDataReport(that, data);
				if(res.data.list !== null){
					that.datas = res.data.list;
				}
				
			},
			search() {
				this.getList();
			}
        },
    }
</script>
<style scoped lang="less">
    .red {
        color: red;
    }

    .multiple {
        display: flex;
        justify-content: left;
        margin-top: 10px;
        align-items: center;

        .child-div {
            width: 70px;
            height: 20px;
            margin-right: 30px;
            text-align-last: justify;
        }
    }

    .hong {
        color: #F56171;
        font-weight: bold;
    }

    .lan {
        color: #124386;
        font-weight: bold;
    }

    .sousuo {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }

    .yl-flex {
        display: flex;
    }

    .flex_between {
        align-items: flex-start;
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
    }

    .green-bg {
        background: #18bc9c;
    }

    .blue-bg {
        background: #54A1F3;
    }

    .person {
        font-size: 14px;
        color: white;
        border-radius: 50%;
        width: 22px;
        height: 20px;
    }

    .in-block {
        display: inline-block;
    }
	/deep/ .ivu-table table {
		width: 100% !important;
	}
	
	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}
	
	/deep/ .ivu-table .table-blue-row td {
		color: #FF6699;
	}
	
	/deep/ .ivu-table .table-black-row td {
		color: black;
	}
	
	/deep/ .client_name {
		display: inline-block;
		margin: 0 4px;
		color: #85c7ff;
	}
</style>
